var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { CatalogsTable } from 'components/Shared/CatalogsTable/CatalogsTable';
import { StyledButton } from 'components/Shared/StyledComponents/StyledButton';
import { catalogHelper } from 'utils/catalog-helper';
import { publishCatalogEventRequest } from 'services/api/catalog-service';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from 'services/auth/AuthProvider';
import { PageContainer } from 'components/Shared/PageContainer/PageContainer';
import { CatalogRunAdditionalFields } from './CatalogRunAdditionalFields/CatalogRunAdditionalFields';
import styles from './CatalogRun.module.scss';
export function CatalogRun() {
    var _this = this;
    var user = useAuth().user;
    var _a = useState({}), selectedCatalogs = _a[0], setSelectedCatalogs = _a[1];
    var _b = useState('CATALOG'), jsonExportType = _b[0], setJsonExportType = _b[1];
    var handleJsonExportTypeChange = function (exportType) {
        setJsonExportType(exportType);
    };
    var effDateEl = document.getElementById('effectiveDate');
    var effTimeEl = document.getElementById('effectiveTime');
    var priceDateOverrideEl = document.getElementById('priceDateOverride');
    var descAppendTextEl = document.getElementById('descAppendText');
    var includeNonPrmtblEl = document.getElementById('includeNonPrmtbl');
    var navigate = useNavigate();
    useEffect(function () {
        var selected = localStorage.getItem('selected');
        if (selected && selected !== 'undefined') {
            var parsed = JSON.parse(selected);
            setSelectedCatalogs(parsed);
        }
    }, []);
    var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var events;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, catalogHelper.buildCatalogExtractEvents(Object.values(selectedCatalogs), effDateEl === null || effDateEl === void 0 ? void 0 : effDateEl.value, effTimeEl === null || effTimeEl === void 0 ? void 0 : effTimeEl.value, includeNonPrmtblEl === null || includeNonPrmtblEl === void 0 ? void 0 : includeNonPrmtblEl.checked, jsonExportType, descAppendTextEl === null || descAppendTextEl === void 0 ? void 0 : descAppendTextEl.value, priceDateOverrideEl === null || priceDateOverrideEl === void 0 ? void 0 : priceDateOverrideEl.value, user)];
                case 1:
                    events = _a.sent();
                    publishCatalogEventRequest(events);
                    localStorage.removeItem('selected');
                    navigate('/catalogs/requests');
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(PageContainer, __assign({ rowGap: 24 }, { children: [_jsx(Typography, __assign({ variant: "h1" }, { children: "Catalog Request" })), _jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'space-between' } }, { children: [_jsx(CatalogRunAdditionalFields, { onJsonExportTypeChange: handleJsonExportTypeChange }), _jsxs(Box, __assign({ sx: { display: 'flex', columnGap: '8px', alignItems: 'flex-end' } }, { children: [_jsx(StyledButton, { label: "Submit", handleClick: function () { return handleSubmit(); }, disabledFromProps: Object.values(selectedCatalogs).length === 0 }), _jsx(Link, __assign({ className: styles.backLink, to: "/catalogs" }, { children: "Back" }))] }))] })), _jsx(CatalogsTable, { catalogs: Object.values(selectedCatalogs), hideCheckBoxColumn: true })] })));
}
